<template>
  <div>
    <navBar/>
    <div class="bg-white h-16"></div>
    <router-view/>
<FooterBar/>
  </div>
</template>

<script>

  import NavBar from './components/NavBar'
  import FooterBar from "./components/FooterBar";


  export default {
    components: {
      FooterBar,
      NavBar,

    }
  }


</script>

<style>


</style>


